import { render, staticRenderFns } from "./PageColumnWithUserEditor.vue?vue&type=template&id=15842874&lang=pug&"
import script from "./PageColumnWithUserEditor.vue?vue&type=script&lang=ts&"
export * from "./PageColumnWithUserEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PageColumnWithUserEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports